const navButtons = [
  { title: 'Detalhes', icon: 'calendar-check-o' },
  { title: 'Cliente', icon: 'user' },
  { title: 'Estado', icon: 'flag-o' },
  { title: 'Estadia', icon: 'bed' },
  { title: 'Pagamento', icon: 'money' },
  { title: 'Consumo', icon: 'coffee' },
  { title: 'Empréstimo', icon: 'exchange' },
  { title: 'Observações', icon: 'pencil-square-o' },
  { title: 'Impressão', icon: 'print' },
  { title: 'Histórico', icon: 'history' },
  { title: 'Opções', icon: 'wrench' },
];
const createButton = (title, icon) =>
  $(`<li class="dropdown"><a href="#"><i class="menu-icon fa fa-${icon} placeholder"></i><span class="menu-text placeholder"> ${title} </span></a></li>`);

export default () => {
  const nav = $(`<nav class="row wrapper border-bottom white-bg no-print">`);
  const ul = $(`</nav><ul class="nav navbar-top-links navbar-booking-menu"></ul>`);
  navButtons.forEach(({ title, icon }) => { ul.append(createButton(title, icon)); });
  nav.append(ul);
  return nav;
}